import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';

export const AVAILABLE_URL_LANGUAGES: { urlParam: string; language: LocalizationLanguage }[] = [
    {
        urlParam: 'en',
        language: LocalizationLanguage.english,
    },
    {
        urlParam: 'nb',
        language: LocalizationLanguage.norwegian,
    },
    {
        urlParam: 'sv',
        language: LocalizationLanguage.swedish,
    },
    {
        urlParam: 'da',
        language: LocalizationLanguage.danish,
    },
    {
        urlParam: 'fi',
        language: LocalizationLanguage.finnish,
    },
];
